/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ViewContacts from './ViewContactList/ViewContactList';
import ViewContactSummary from './ViewContactSummary/ViewContactSummary';
import ViewContactAdd from './ViewContactAdd/ViewContactAdd';
import ViewContactEdit from './ViewContactEdit';
import ViewContactSpecialty from './ViewContactSpecialty';
import ViewContactCustomSpecialty from './ViewContactCustomSpecialty';
import ViewContactRelationship from './ViewContactRelationship';
import ViewContactCustomRelationship from './ViewContactCustomRelationship';
import ViewContactDetailLabel from './ViewContactDetailLabel';
import ViewContactEditNew from './ViewContactEditNew';
import ViewContactHealthcareProxy from './ViewContactHealthcareProxy';

import RouteNames from '../../appAuthorized/RouteNames';

class ContactRoutes extends React.Component {

  render() {
    return (
      <Switch>
        <Route path={RouteNames.contactDetail()} component={ViewContactDetailLabel} />
        <Route exact path={RouteNames.contactSpecialty()} component={ViewContactSpecialty} />
        <Route exact path={RouteNames.contactCustomSpecialty()} component={ViewContactCustomSpecialty} />
        <Route exact path={RouteNames.contactRelationship()} component={ViewContactRelationship} />
        <Route exact path={RouteNames.contactCustomRelationship()} component={ViewContactCustomRelationship} />

        <Route exact path={RouteNames.contactHealthcareProxy()} component={ViewContactHealthcareProxy} />

        <Route exact path={RouteNames.contactEditNew()} component={ViewContactEditNew} />
        <Route exact path={RouteNames.contactAdd()} component={ViewContactAdd} />

        <Route exact path={RouteNames.contactEdit()} component={ViewContactEdit} />
        <Route exact path={RouteNames.contact()} component={ViewContactSummary} />

        <Route path={RouteNames.contactList()} component={ViewContacts} />
      </Switch>
    );
  }
}

export default ContactRoutes;
